import { render, staticRenderFns } from "./UpdateInsruction.vue?vue&type=template&id=74d39ffe&scoped=true&"
import script from "./UpdateInsruction.vue?vue&type=script&lang=js&"
export * from "./UpdateInsruction.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInsruction.vue?vue&type=style&index=0&id=74d39ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d39ffe",
  null
  
)

export default component.exports